<template>
    <div class="mls-declaimer-container-v2">
        <div class="declaimer" v-for="mls in mlsOrgs" :key="mls.id">
            <div class="site-p content" :class="declaimerCls" v-if="mls.declaimer" v-html="mls.declaimer"></div>
            <div class="mls-logo" v-if="mls.logo">
                <site-img alt="mls logo" class="logo" :src="mls.logo" backSize="contain" backPos="left"></site-img>
            </div>
        </div>
    </div>
</template>

<script>
import com from './mls-disclaimer.js'


export default {
    ...com
}
</script>

<style lang="scss">
.mls-declaimer-container-v2 {
    color: #a0a3af;
    font-size: 13px;
    line-height: 150%;
    padding-top: 30px;
    @media (max-width: 600px) {
        padding-top: 20px;
    }
    .declaimer {
        .content.site-p {
            margin-top: 0;
            text-align: center;
        }
        .mls-logo {
            margin-top: 10px;
            .logo {
                height: 30px;
                display: block;
                margin: 0 auto;
            }
        }
        .mls-logo:first-child{
            margin-top: 0;
        }
    }
    .declaimer+.declaimer{
        margin-top: 30px;
    }
    @media (max-width: 600px) {
        .declaimer+.declaimer{
            margin-top: 20px;
        }
    }
}
</style>
